 import Vue from 'vue'
import router from './router'
import store from './store'
import App from './App.vue'
import VueSocketIO from 'vue-socket.io'
import Buefy from 'buefy'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import VueGtag from "vue-gtag";

import 'bulma/css/bulma.css';
import 'buefy/dist/buefy.css'

import './assets/style.scss'

import ApiService from './common/api.service'

Vue.config.productionTip = process.env.NODE_ENV === 'production'
Vue.prototype._ = _

ApiService.init()

Vue.use(Buefy)
Vue.use(VueLodash, { lodash })

Vue.use(new VueSocketIO({
  debug: false,
  connection: process.env.VUE_APP_API,
  vuex: {
      store,
      actionPrefix: 'SOCKET_',
      mutationPrefix: 'SOCKET_',
  },
}))


Vue.use(VueGtag, {
  config: { id: "AW-974458431" }
}, router);


export default new Vue({
  router: router,
  store: store,
  render: (h) => h(App),
}).$mount('#app')
